// Environment configuration loaded from .env files
// Vite automatically loads .env.[mode] files based on --mode flag

const envData = {
  APP_BASE_NAME: import.meta.env.VITE_APP_BASE_NAME,
  APP_API_TOKEN: import.meta.env.VITE_APP_API_TOKEN,
  APP_PROPERTY_TITLE: import.meta.env.VITE_APP_PROPERTY_TITLE,
  BASE_URL: import.meta.env.VITE_BASE_URL,
  APP_API_GATEWAY: import.meta.env.VITE_APP_API_GATEWAY,
  APP_LOGIN: import.meta.env.VITE_APP_LOGIN,
  APP_CLOUDFRONT_URLIMG: import.meta.env.VITE_APP_CLOUDFRONT_URLIMG,
  MOVIE: Number(import.meta.env.VITE_MOVIE),
  PROGRAMMES: Number(import.meta.env.VITE_PROGRAMMES),
  SEASON: Number(import.meta.env.VITE_SEASON),
  PLACEHOLDER_IMG_URL: import.meta.env.VITE_PLACEHOLDER_IMG_URL,
  APP_DOWNLOAD_BASE_URL: import.meta.env.VITE_APP_DOWNLOAD_BASE_URL,
  IMAGES_BUCKET: import.meta.env.VITE_IMAGES_BUCKET,
  USE_FAKE_MODEL: import.meta.env.VITE_USE_FAKE_MODEL === "true",
  CLOUDFRONT_CHANNELS_LOGOS_URL: import.meta.env
    .VITE_CLOUDFRONT_CHANNELS_LOGOS_URL,
};

export default envData;
